import { Box } from '@mui/material'
import { GridColDef, GridRowId } from '@mui/x-data-grid-premium'
import { useMemo } from 'react'
import {
  ConstrainingParametersDataType,
  ConstrainingParametersTableProps,
} from './Tables.types'
// Toolbar import removed - functionality moved to BaseTable
// Modal imports removed - bulk update now handled by BaseTable toolbar
import { format } from 'date-fns'
// DropZone now integrated into BaseTable toolbar
import { BaseTable } from 'Features/Table/BaseTable.view'

const numericalFields = [
  'maxPreBuildPeriodWeeks',
  'constrainingPriorityOrder',
  'autoBowWaveConstrainingOrder',
  'maxDelayBowWave',
  'bowWaveSafetyStockShort',
  'safetyStockFactor',
  'moqFactor',
]
const stringFields = [
  'holdPreBuildStockAtManufacturingSite',
  'keepFullBatchWhenConstraining',
]
export const ConstrainingParameterTable = ({
  data,
  isLoading,
  updateTableData,
  updateParametersData,
  isUploading,
}: ConstrainingParametersTableProps) => {
  // Modal state and handlers removed - bulk update now handled by BaseTable toolbar

  const columns: GridColDef[] = useMemo(
    () => [
      {
        headerName: 'Base source site code',
        field: 'baseSourceSiteCode',
        flex: 1,
        type: 'string',
      },
      {
        headerName: 'SKU code',
        field: 'skuCode',
        flex: 1,
        type: 'string',
      },
      {
        headerName: 'Max pre build period (weeks)',
        field: 'maxPreBuildPeriodWeeks',
        flex: 1,
        type: 'number',
        editable: true,
      },
      {
        headerName: 'Constraining priority order',
        field: 'constrainingPriorityOrder',
        flex: 1,
        type: 'number',
        editable: true,
      },
      {
        headerName: 'Auto bow wave constraining order',
        field: 'autoBowWaveConstrainingOrder',
        flex: 1,
        type: 'number',
        editable: true,
      },
      {
        headerName: 'Max delay bow wave',
        field: 'maxDelayBowWave',
        flex: 1,
        type: 'number',
        editable: true,
      },
      {
        headerName: 'Bow wave safety stock short',
        field: 'bowWaveSafetyStockShort',
        flex: 1,
        type: 'number',
        editable: true,
      },
      {
        headerName: 'Hold pre build stock at manufacturing site',
        field: 'holdPreBuildStockAtManufacturingSite',
        flex: 1,
        type: 'boolean',
        editable: true,
      },
      {
        headerName: 'Keep full batch when constraining',
        field: 'keepFullBatchWhenConstraining',
        flex: 1,
        type: 'boolean',
        editable: true,
      },
      {
        headerName: 'Safety stock factor',
        field: 'safetyStockFactor',
        flex: 1,
        type: 'number',
        editable: true,
      },
      {
        headerName: 'MOQ factor',
        field: 'moqFactor',
        flex: 1,
        type: 'number',
        editable: true,
      },
      {
        headerName: 'Valid from date',
        field: 'validFromDate',
        flex: 1,
        type: 'string',
        valueFormatter: (params) => {
          if (!params) return ''
          return format(new Date(params), 'yyyy-MM-dd')
        },
      },
      {
        headerName: 'Valid to date',
        field: 'validToDate',
        flex: 1,
        type: 'string',
        valueFormatter: (params) => {
          if (!params) return ''
          return format(new Date(params), 'yyyy-MM-dd')
        },
      },
    ],
    [data]
  )

  return (
    <Box
      sx={{
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        height: '100%',
        minHeight: 0,
      }}
    >
      <BaseTable
        data={data ?? []}
        columns={columns}
        isLoading={isLoading}
        updateTableData={updateTableData}
        uploadData={updateParametersData} // Pass upload function to BaseTable
        isUploading={isUploading}
        isSaving={false}
        checkBoxSelection={true}
        showTableToolBar={true}
        pinnedColumns={['baseSourceSiteCode', 'skuCode']}
        downloadFileName="ConstrainingParameters"
      />
    </Box>
  )
}
